import { useEffect } from 'react';
import { getLocalStorage, setLocalStorage } from '../utils/localStorage';

export const useVehicleStorage = ({ vehicleId }) => {
	const myCarsLocalState = getLocalStorage();

	const buildMyCarsStorage = (id, myCarsState) => {
		// if myCarsState is null, return null
		if (myCarsState === null) {
			return null;
		}

		const vehicles = myCarsState.vehicles ? [...myCarsState.vehicles] : [];

		const vehicleIndex = vehicles.findIndex(
			(vehicle) => vehicle.uuid === id
		);

		// Get timestamp
		const date = Math.floor(Date.now() / 1000);

		if (vehicleIndex === -1) {
			// if vehicle does not exist in myCarsState add it
			vehicles.push({
				uuid: id,
				viewed: date
			});
		} else {
			// if vehicle exists in myCarsState update it
			vehicles[vehicleIndex] = {
				...vehicles[vehicleIndex],
				viewed: date
			};
		}

		const newMyCarsState = {
			...myCarsState,
			vehicles
		};

		return newMyCarsState;
	};

	useEffect(() => {
		const handleViewVehicle = (id, myCarsState) => {
			const newState = buildMyCarsStorage(id, myCarsState);
			setLocalStorage(newState);
		};

		if (myCarsLocalState) {
			handleViewVehicle(vehicleId, myCarsLocalState);
		}
	}, [vehicleId, myCarsLocalState]);
};
